// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__v3Vwk","caption":"TextInput_caption__LQV2f","input":"TextInput_input__YOUtH"};